import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingWriteButton from './components/FloatingWriteButton';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Contact from './pages/Contact';
import News from './pages/News';
import Pricing from './pages/Pricing';
import Blog from './pages/Blog';
import BlogWrite from './pages/BlogWrite';
import BlogDetail from './pages/BlogDetail';
import BlogManage from './pages/BlogManage';
import BlogEdit from './pages/BlogEdit';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { AuthPage } from './pages/AuthPage';
import { Dashboard } from './pages/Dashboard';
import { AdminPage } from './pages/AdminPage';
import { CollectionPage } from './pages/CollectionPage';
import { HistoryPage } from './pages/HistoryPage';
import { BillingPage } from './pages/BillingPage';
import { AnalysisPage } from './pages/AnalysisPage';
import { ProfilePage } from './pages/ProfilePage';
import CollectorDashboard from './pages/CollectorDashboard';
import CollectionRequestPage from './pages/CollectionRequestPage';
import CollectorTasksPage from './pages/CollectorTasksPage';
import { Receipt } from './pages/Receipt';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';
import './App.css';
import './App.css';

const AppContent: React.FC = () => {
  const location = useLocation();
  const isWritePage = location.pathname === '/blog/write';
  const isBlogDetailPage = location.pathname.startsWith('/blog/') && location.pathname !== '/blog';
  const isProduction = process.env.NODE_ENV === 'production';
  const shouldHideFooter = isWritePage;

  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/news" element={<News />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/write" element={<BlogWrite />} />
        <Route path="/blog/manage" element={<BlogManage />} />
        <Route path="/blog/edit/:id" element={<BlogEdit />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        
        {/* SSLMO 라우트들 */}
        <Route path="/sslmo" element={<AuthPage />} />
        <Route path="/sslmo/login" element={<AuthPage />} />
        <Route path="/sslmo/dashboard" element={
          <ProtectedRoute requiredRole="user">
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/collection" element={
          <ProtectedRoute requiredRole="user">
            <Layout>
              <CollectionPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/history" element={
          <ProtectedRoute requiredRole="user">
            <Layout>
              <HistoryPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/billing" element={
          <ProtectedRoute requiredRole="user">
            <Layout>
              <BillingPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/analysis" element={
          <ProtectedRoute requiredRole="user">
            <Layout>
              <AnalysisPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/profile" element={
          <ProtectedRoute requiredRole="user">
            <Layout>
              <ProfilePage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/receipt/:id" element={
          <ProtectedRoute requiredRole="user">
            <Layout>
              <Receipt />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/collector/dashboard" element={
          <ProtectedRoute requiredRole="collector">
            <Layout>
              <CollectorDashboard />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/collector/requests" element={
          <ProtectedRoute requiredRole="collector">
            <Layout>
              <CollectionRequestPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/collector/tasks" element={
          <ProtectedRoute requiredRole="collector">
            <Layout>
              <CollectorTasksPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sslmo/admin" element={
          <ProtectedRoute requiredRole="admin">
            <Layout>
              <AdminPage />
            </Layout>
          </ProtectedRoute>
        } />
      </Routes>
      {!shouldHideFooter && <Footer />}
      {!isWritePage && !isBlogDetailPage && !isProduction && <FloatingWriteButton />}
    </div>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthProvider>
        <Router basename="/">
          <AppContent />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}
  
export default App;